<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' :productType='productType' class="header"></Header>
    <div class="content">
      <div class="top">
        <div class="top_left">
          <img src="../../assets/product/product/p1_1.png" class="img_big" v-if="active==1"/>
          <img src="../../assets/product/product/p1_2.png" class="img_big" v-if="active==2"/>
          <img src="../../assets/product/product/p1_3.png" class="img_big" v-if="active==3"/>
          <div class="img_box">
            <div class="img_icon_box">
              <img src="../../assets/plan/left.png" class="img_icon" @click="reduce(3)"/>
            </div>
            <div class="img_small_box">
              <img src="../../assets/product/product/p1_1.png" :class="['img_small', active==1?'img_small_active' : ''] " @click="changeImg(1)"/>
              <img src="../../assets/product/product/p1_2.png" :class="['img_small', active==2?'img_small_active' : ''] " @click="changeImg(2)"/>
              <img src="../../assets/product/product/p1_3.png" :class="['img_small', active==3?'img_small_active' : ''] " @click="changeImg(3)"/>
            </div>
            <div class="img_icon_box">
              <img src="../../assets/plan/right.png" class="img_icon" @click="add(3)"/>
            </div>
          </div>
        </div>
        <div class="top_right">
          <h3>任马停-智能停车收费控制机</h3>
          <h4>RMT500-2017-02</h4>
          <h5>￥15,000<span>/套</span></h5>
          <p>包含停车识别一体机、高速道闸、防砸雷达及企业路由器、交换机、线缆、管材、室外防雨箱等配套设备。</p>
          <div class="link" @click="link">查看车道监控产品详情>></div>
        </div>
      </div>
      <div class="introduce">
        <h3>产品介绍</h3>
        <p>
          停车识别一体机：<br>
          一体化嵌入式车牌识别一体机，集成车牌识别、LED显示、语音播报功能一体<br>
          摄像头像素：500万<br>
          车辆号牌识别准确率率：≥99.9%<br>
          识别虚假车牌：<br>
          能识别人员手持车牌、手机展示车牌照片、静态车辆图片等虚假车牌情况并过滤<br>
          高速道闸：<br>
          机芯：直流无刷机芯<br>
          抬杆时间：1.5~6秒<br>
          运行噪音：59dB<br>
          连续过车功能：支持于连续过车模式，连续过车时道闸不落杆<br>
          防砸雷达：<br>
          识别准确率：≥99%<br>
          测距范围：0.1-10m<br>
          调制模式：FMCW调制模式<br>
          使用寿命长：≥10年<br>
        </p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Product1',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'product',
      productType: 1,
      active: 1
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    link() {
      this.$router.push('/Product2')
    },
    changeImg(active) {
      this.active=active
    },
    add (max) {
      if (this.active>=max) {
        this.active=1
      } else {
        this.active++
      }
    },
    reduce (max) {
      if (this.active<=1) {
        this.active=max
      } else {
        this.active--
      }
    },
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin: 0 auto;
  margin-top: 160px;
  width: 1000px;
}

.top {
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.top_left {
  width: 320px;
  margin-right: 50px;
}
.img_big {
  width: 320px;
  height: 320px;
}
.img_box {
  width: 320px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.img_box .img_icon_box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eee;
  border-radius: 3px;
  width: 20px;
  height: 50px;
}
.img_icon_box .img_icon {
  width: 10px;
  cursor: pointer;
}
.img_small_box {
  flex: 1;
  display: flex;
  overflow: auto;
}
.img_small {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
}
.img_small_active {
  border: 1px #333 solid;
}

.top_right {
  flex: 1;
  text-align: left;
  color: #333;
}
.top_right h3 {
  font-size: 24px;
}
.top_right h4 {
  font-size: 18px;
  margin: 10px 0;
}
.top_right h5 {
  font-size: 28px;
  margin: 20px 0;
  margin-bottom: 30px;
  color: red;
}
.top_right h5  span {
  font-size: 18px;
}
.top_right .link {
  color: #409EFF;
  margin-top: 30px;
  cursor: pointer;
}

.introduce {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  color: #333;
  text-align: left;
}
.introduce h3 {
  font-weight: bolder;
  font-size: 20px;
  margin-bottom: 20px;
}
.introduce p {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/product1.vue